import { Suspense, lazy } from 'react';

const LiveScene = lazy(() =>
  import('./LiveScene').then((mod) => ({ default: mod.LiveScene })),
);

/**
 * Top-level hero scene wrapper. No surrounding border / background / rounded
 * box — the scene renders directly on the page canvas so it feels embedded,
 * not framed.
 */
export function AnimatedBuildingScene() {
  return (
    <div className="relative w-full aspect-[640/560]">
      <Suspense fallback={<SceneSkeleton />}>
        <LiveScene />
      </Suspense>
    </div>
  );
}

function SceneSkeleton() {
  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 flex items-center justify-center"
    >
      <span className="font-mono text-[10px] uppercase tracking-[0.125em] text-ink-subtle zg-pulse-dot">
        &gt; LOADING_SCENE
      </span>
    </div>
  );
}
